import styles from "./MainTitle.module.scss";
import React from "react";

interface MainTitleProps {
  text: string;
  size?: number;
}

const MainTitle: React.FC<MainTitleProps> = ({ text, size = 30 }) => {
  return (
    <h2 className={styles.title} style={{ fontSize: size + "px" }}>
      {text}
    </h2>
  );
};

export default MainTitle;
